import {
  slideInUp,
  slideInDown,
  slideInLeft,
  slideInRight,
  slideOutUp,
  slideOutDown,
  slideOutLeft,
  slideOutRight,
} from 'ng-animate';

import { trigger, transition, useAnimation, AnimationTriggerMetadata } from '@angular/animations';

// ENTER

export const snSlideInUp: AnimationTriggerMetadata = trigger('snSlideInUp', [
  transition(':enter', useAnimation(slideInUp), {
    params: { timing: 0.3 },
  }),
]);

export const snSlideInDown: AnimationTriggerMetadata = trigger('snSlideInDown', [
  transition(':enter', useAnimation(slideInDown), {
    params: { timing: 0.3 },
  }),
]);

export const snSlideInLeft: AnimationTriggerMetadata = trigger('snSlideInLeft', [
  transition(':enter', useAnimation(slideInLeft), {
    params: { timing: 0.3 },
  }),
]);

export const snSlideInRight: AnimationTriggerMetadata = trigger('snSlideInRight', [
  transition(':enter', useAnimation(slideInRight), {
    params: { timing: 0.3 },
  }),
]);

// LEAVE

export const snSlideOutUp: AnimationTriggerMetadata = trigger('snSlideOutUp', [
  transition(':leave', useAnimation(slideOutUp), {
    params: { timing: 0.3 },
  }),
]);

export const snSlideOutDown: AnimationTriggerMetadata = trigger('snSlideOutDown', [
  transition(':leave', useAnimation(slideOutDown), {
    params: { timing: 0.3 },
  }),
]);

export const snSlideOutLeft: AnimationTriggerMetadata = trigger('snSlideOutLeft', [
  transition(':leave', useAnimation(slideOutLeft), {
    params: { timing: 0.3 },
  }),
]);

export const snSlideOutRight: AnimationTriggerMetadata = trigger('snSlideOutRight', [
  transition(':leave', useAnimation(slideOutRight), {
    params: { timing: 0.3 },
  }),
]);
